export default __webpack_public_path__ + "static/media/hht2_ep_08.94133e45.png";